import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import SelectInput from '@/common/components/SelectInput';
import { SearchBarCenter } from '@/common/styles/SearchBars';

const SearchBox = ({ hook }) => {
	return (
		<SearchBarCenter>
			<div>
				<Input
					name='Creation date from'
					width={180}
					color={Colors.darkBlue}
					inputRef={hook.dateFromRef}
					type='date'
					value={hook.today}
					inputWidth={140}
				/>
				<Input
					name='Creation date to'
					width={180}
					color={Colors.darkBlue}
					inputRef={hook.dateToRef}
					type='date'
					value={hook.today}
					inputWidth={140}
				/>
			</div>
			<div>
				<SelectInput
					showLabel={false}
					placeholder={'Select queues...'}
					selectWidth={400}
					options={hook.queuesOptions}
					setSelected={hook.setSelectedQueues}
					selected={hook.selectedQueues}
					multiple={true}
				/>
			</div>
			<ActionButton text='Search' onClick={(e) => hook.handleSearch(e)} />
		</SearchBarCenter>
	);
};

export default SearchBox;
